module.exports = __webpack_public_path__ + "img/107.0a5285d4.png";